/*
 * Copyright © 2024-2026 symecode.com. All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, modification, or distribution is prohibited.
 */


import React from 'react';
import './PaymentConfirmationModal.css';

interface PaymentConfirmationModalProps {
  costFormatted: string;
  creditsFormatted: string;
  isFreeCost: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const PaymentConfirmationModal: React.FC<PaymentConfirmationModalProps> = ({
  costFormatted,
  creditsFormatted,
  isFreeCost,
  onConfirm,
  onCancel
}) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content payment-confirmation-modal">
        <h2>Generate PDF Package</h2>

        {isFreeCost ? (
          <div className="modal-body">
            <p className="cost-info">
              Bid Generation costs <strong>{costFormatted}</strong>
            </p>
            <p className="action-prompt">
              Click Continue to generate bid.
            </p>
          </div>
        ) : (
          <div className="modal-body">
            <p className="cost-info">
              This will cost <strong>{costFormatted}</strong>
            </p>
            <p className="credits-info">
              Your current balance: <strong>{creditsFormatted}</strong>
            </p>
            <p className="action-prompt">
              The cost will be deducted from your company credits.
            </p>
          </div>
        )}

        <div className="modal-actions">
          <button
            className="cancel-button"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="confirm-button"
            onClick={onConfirm}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentConfirmationModal;
